import { ModifiedShipmentTrackingStatus, ShipmentTrackingStatus } from "./enums";

export const shipmentStatus = (status?: string) => {
  if (status)
    switch (status.toLowerCase()) {
      case ShipmentTrackingStatus.ARRIVED_AT_PORT_OR_DISCHARGE.toLowerCase():
        return ModifiedShipmentTrackingStatus.ARRIVED_AT_PORT_OF_DISCHARGE;
      case ShipmentTrackingStatus.WAITING_AT_DESTINATION_PORT.toLowerCase():
        return ModifiedShipmentTrackingStatus.WAITING_AT_PORT_OF_DISCHARGE;
      case ShipmentTrackingStatus.LEFT_THE_DESTINATION_PORT.toLowerCase():
        return ModifiedShipmentTrackingStatus.DEPARTED_FROM_PORT_OF_DISCHARGE;
      default:
        return status;
    }
};
